export const SPA_TYPE_INFO = 'SPA_INFO';
export const SPA_TYPE_CATEGORY = 'CATEGORY';
export const SPA_TYPE_TREATMENTS = 'TREATMENTS';
export const SPA_TYPE = 'spa_type';
export const TREATMENT_TYPE = 'treatment_type';
export const SPA_INFO_VIEW = 'spa_info_view';

export const SPA_INFO_CREATE = 'spa_info_create';
export const SPA_INFO_EDIT = 'spa_info_edit';
export const CATEGORY_VIEW = 'category_view';
export const CATEGORY_CREATE = 'category_create';
export const CATEGORY_EDIT = 'category_edit';
export const TREATMENTS_VIEW = 'treatments_view';
export const TREATMENTS_CREATE = 'treatments_create';
export const TREATMENTS_EDIT = 'treatments_edit';

export const DAYS = [
  { id: 1, ischecked: false, name: 'Monday', from: null, to: null },
  { id: 2, ischecked: false, name: 'Tuesday', from: null, to: null },
  { id: 3, ischecked: false, name: 'Wednesday', from: null, to: null },
  { id: 4, ischecked: false, name: 'Thursday', from: null, to: null },
  { id: 5, ischecked: false, name: 'Friday', from: null, to: null },
  { id: 6, ischecked: false, name: 'Saturday', from: null, to: null },
  { id: 7, ischecked: false, name: 'Sunday', from: null, to: null },
];

export const TYPE_VALUES = {
  UNISEX: 'Unisex',
  COUPLES: 'Couples',
  MALE: 'Male Only',
  FEMALE: 'Female Only',
};

export const TYPE_LIST = [
  { id: 'UNISEX', name: 'Unisex', selected: false },
  { id: 'COUPLES', ischecked: false, name: 'Couples' },
  { id: 'MALE', ischecked: false, name: 'Male Only' },
  { id: 'FEMALE', ischecked: false, name: 'Female Only' },
];

export const ALL_DAY = 'all day';

export const REDIRECT_OPTIONS = ['External URL', 'SPA Booking Flow'];

export const TREATMENT_FILTER_DATA_TYPE = [
  { id: 'COUPLES', name: 'Couples', selected: false },
  { id: 'MALE', name: 'Male Only', selected: false },
  { id: 'FEMALE', name: 'Female Only', selected: false },
  { id: 'UNISEX', name: 'Unisex', selected: false },
];

export const TREATMENT_FILTER_DATA = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Category',
    field: 'spaCategoryId',
    subMenu: [],
  },
  {
    title: 'Spa',
    field: 'spaId',
    subMenu: [],
  },
  {
    title: 'Pax',
    field: 'type',
    subMenu: TREATMENT_FILTER_DATA_TYPE,
  },
];
export const SPA_INFO_TAB_LIST = ['Details', 'Hours', 'Contact', 'Location', 'CTA', 'Media'];
export const SPA_CATEGORY_TAB_LIST = ['Details', 'Media'];
export const SPA_TREATMENT_TAB_LIST = ['Details', 'Duration', 'Media'];
